<template>
  <div class="fundCenterView"
       ref="fundCenterView">
       <el-row>
      <el-col :span="6">
        <div class="grid-content ">
          <div class="inline">
            <img :src="fundamount"
                 alt=""
                 class="icon">
            <span class="title">可提现总金额（元）</span>
          </div>
          <div class="moneyLine">
            <span class="moneyType">￥</span>
            <span class="money">{{ getMoney(canWithdrawMoney) }}</span>
          </div>
        </div>
      </el-col>
    
    </el-row>
    <div class="tableView">
      <div class="tableTabs">
        <el-tabs v-model="tabActiveName"
                 @tab-click="handleClick">
          <el-tab-pane :name="item.name"
                       :label="item.name"
                       v-for="item, index in tabsList"
                       :key="index">
            <span v-if="item.count  > 0"
                  slot="label">{{item.name}}
              <el-badge :value="item.count"
                        class="item" />
            </span>
          </el-tab-pane>
        </el-tabs>
        <el-form ref="form"
                 :model="form"
                 :inline="true">
          <el-form-item>
            <el-input v-model.trim="form.orderId"
                      size="small"
                      placeholder="请输入订单ID"
                      clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="form.dateValue"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="订单开始日期"
                            end-placeholder="订单结束日期"
                            size="small"
                            clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input v-model.trim="form.erpOrName"
                      size="small"
                      placeholder="请输入客户ERP编码/客户名称"
                      style="width:240px"
                      clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="form.type"
                       placeholder="收支类型"
                       size="small"
                       clearable>
              <el-option v-for="item in withdrawType"
                         :key="item.code"
                         :label="item.value"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small"
                       type="primary"
                       @click="queryFirstPage">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <withdrawListTable :tableHeight="tableHeight"
                         v-show="tabActiveName == '收支明细'"
                         ref="withdrawTable"
                         @pageInfoDidChange="pageInfoDidChange" />
      <moneyListTable :tableHeight="tableHeight"
                      v-show="tabActiveName == '提现申请'"
                      ref="applyTable"
                      @pageInfoDidChange="pageInfoDidChange"
                       />
      <div class="paninationView">
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-sizes="[10, 20, 30, 50, 100]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
   
  </div>
</template>
<script>
import withdrawListTable from "./withdrawListTable";
import moneyListTable from "./moneyListTable";
import fundamount from "@/assets/fundamount.png";
import { withdrawalMoney } from "@/api/fund/fundApi";
import dayjs from "dayjs";
import _ from "lodash";

export default {
  components: { withdrawListTable, moneyListTable },
  data () {
    return {
      loading: false,
      tabsList: [{ name: '收支明细', count: '' }, { name: '提现申请', count: '' }],
      tabActiveName: '收支明细',
      tableHeight: 0,
      dialogTableHeight: 0,
      fundamount: fundamount,
      form: {
        erpOrName: '',
        dateValue: [],
        type: '',
        orderId: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 10,
      withdrawType: [{ code: 'INCOME', value: '收入' }, { code: 'EXPENDITURE', value: '提现' }],
      canWithdrawMoney: '',//可提现金额
    }
  },
  mounted () {
    this.tableHeight = this.$refs.fundCenterView.offsetHeight - 120 - 56 - 56 - 40
    this.dialogTableHeight = this.$refs.fundCenterView.offsetHeight * 0.6
    this.getSubmitCnt()
    this.getList()
    this.getCanWithdrawMoney()
  },
  methods: {
    async getCanWithdrawMoney () {
      const obj = {  }
      let query = this.$route.query;
      if(query.shopId){
        obj['shopId'] = query.shopId;
      }
      const resp = await withdrawalMoney(obj)
      if (resp) {
        this.canWithdrawMoney = resp
      }
    },
    getMoney (e) {
      if (!e) {
        return '0.00'
      } else {
        return e.toFixed(2)
      }
    },
    pendParams (type = 'query') {
      let obj = type == 'query' ? { current: this.currentPage, size: this.pageSize } : {}
      obj['name'] = this.form.erpOrName || null //	请输入客户ERP编码/客户名称	query	false	
      obj['orderCode'] = this.form.orderId || null //	订单编码	query	false	
      if (this.form.dateValue && this.form.dateValue.length) {
        obj['startDate'] = dayjs(this.form.dateValue[0]).format('YYYY-MM-DD')
        obj['endDate'] = dayjs(this.form.dateValue[1]).format('YYYY-MM-DD')
      }
      obj['amountType'] = this.form.type || null //amountType:'',//	余额变动类型,可用值:INCOME,EXPENDITURE	query	false	
      let query = this.$route.query;
      if(query.shopId){
        obj['shopId'] = query.shopId;
      }
      return obj
    },
    queryFirstPage () {
      this.currentPage = 1
      this.getList()
    },
    async getSubmitCnt () {
      // 获取部门申请数量
      let shopId = this.$route.query.shopId
      const resp = await submitCntForOPS({shopId})
      if (resp) {
        this.tabsList = [{ name: '收支明细', count: '' }, { name: '提现申请', count: resp || '' }]
      }
    },
    handleClick (e) {
      this.currentPage = 1
      this.getList()
    },
    getList () {
      const obj = this.pendParams()
      if (this.tabActiveName == '收支明细') {
        this.$refs.withdrawTable?.getList(obj)
      } else {
        this.$refs.applyTable?.getList(obj)
      }
    },
    handleSizeChange (e) {
      // this.resetPageInfo()
      this.pageSize = e
      this.getList()
    },
    handleCurrentChange (e) {
      // this.resetPageInfo()
      this.currentPage = e
      this.getList()
    },
    pageInfoDidChange (e) {
      // 分页数据改变  得到总页数等 current: 1   total: 95
      this.currentPage = e.current
      this.total = e.total
    }
  }
}
</script>
<style lang="scss" scoped>
.fundCenterView {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  height: 100%;

  .row-bg {
    background: #fff;
  }

  .grid-content {
    height: 120px;
    padding: 24px;
  }

  .tableView {
    background-color: #fff;
    padding: 0px 24px;

    .tableTabs {
      ::v-deep(.el-tabs__active-bar) {
        bottom: 6px !important;
      }

      ::v-deep(.el-date-editor .el-range-input) {
        width: 50%;
      }
    }

    .flexRight {
      display: flex;
      align-items: flex-end;
      flex-direction: column;
    }
  }

  .inline {
    display: flex;
    align-items: center;

    .icon {
      width: 22px;
      height: 22px;
    }

    .title {
      color: #595959;
      font-size: 14px;
      margin-left: 5px;
    }
  }

  .moneyLine {
    display: flex;
    align-items: flex-end;
    color: rgba($color: #000000, $alpha: 0.85);
    margin-top: 10px;

    .moneyType {
      font-weight: 700;
      font-style: 16px;
      // margin-bottom: 3px;
    }

    .money {
      font-weight: 700;
      font-size: 30px;
      line-height: 1;
      margin-right: 12px;
    }
  }

  .account {
    margin-top: 10px;
    color: #262626;
    font-size: 14px;
    font-weight: 400;
  }

  .cardView {
    margin-top: 10px;
  }

  .checkView {
    display: flex;
    align-items: center;
    margin-left: 24px;
    cursor: pointer;
  }
  .paninationView {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>